import { VISUAL_GAME_SECTION_DEFINITIONS } from '@drama/contracts/visual-game'

export const SECTION_DEFINITIONS = VISUAL_GAME_SECTION_DEFINITIONS

const SECTION_MAP = new Map(SECTION_DEFINITIONS.map(section => [section.id, section]))

/**
 * @param {string} id
 */
export function sectionDefinitionById(id) {
  const section = SECTION_MAP.get(id)
  if (!section) throw new Error(`Unknown visual-game scenario section: ${id}`)
  return section
}

export function publicSectionDefinitions() {
  return SECTION_DEFINITIONS.map(({ id, title, file, description }) => ({ id, title, file, description }))
}
